import { Card } from "../../../components/card/card.jsx";
import { DataTable } from "../../../components/table/table.tsx";
import { useEffect, useState } from "react";
import { apiUrl } from "../../../config/config.js";
import Swal from "sweetalert2";

import TournamentDetailModal from '../tournaments/tournamentDetail.js';

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

function Tournaments() {
	const [tournaments, setTournaments] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	//Para el crear o editar un torneo
	const [selectedTournament, setSelectedTournament] = useState(null);
	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		fetchTournaments();
	}, []);

	const fetchTournaments = async () => {
		setIsLoading(true);
		try {
			const response = await fetch(`${apiUrl}/tournaments-all`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				}
			});

			if (response.ok) {
				const { data } = await response.json();

				const dataMapped = data.map((item) => ({
					...item,
					startDate: new Date(item.startDate).toLocaleDateString(),
					endDate: new Date(item.endDate).toLocaleDateString(),
				}));

				setTournaments(dataMapped || []);
			} else {
				Toast.fire({
					icon: "error",
					title: "Error al cargar los torneos",
					background: "#1e2836",
				});
			}
		} catch (error) {
			console.error("Error fetching tournaments:", error);
			Toast.fire({
				icon: "error",
				title: "Error al cargar los torneos",
				background: "#1e2836",
			});
		}
		setIsLoading(false);
	}

	if (isLoading) {
		return (
			<div className="text-center">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Cargando...</span>
				</div>
			</div>
		);
	}

	const openModalForCreate = () => {
		setSelectedTournament(null);
		setShowModal(true);
	}

	const openModalForUpdate = async (tournamentId) => {
		try {
			const response = await fetch(`${apiUrl}/tournaments/${tournamentId}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				}
			});
			if (response.ok) {
				const { data } = await response.json();
				setSelectedTournament(data || null);
				setShowModal(true);
			} else {
				Toast.fire({
					icon: "error",
					title: "Error al cargar el torneo",
					background: "#1e2836",
				});
			}
		} catch (error) {
			console.error("Error fetching tournament by id:", error);
			Toast.fire({
				icon: "error",
				title: "Error al cargar el torneo",
				background: "#1e2836",
			});
		}
	}

	const onDeleteTournamente = async (id) => {
		try {
			const response = await fetch(`${apiUrl}/tournaments/${id}`, {
				method: "DELETE",
			});

			if (response.ok) {
				Toast.fire({
					icon: "success",
					title: `Torneo ha sido eliminado con éxito`,
					background: "#1e2836",
					color: "#fff",
				});
				await fetchTournaments();
			} else {
				Toast.fire({
					icon: "error",
					title: "Error al intentar eliminar el torneo",
					background: "#1e2836",
				});
			}

		} catch (error) {
			console.error("Error eliminando el torneo:", error);
			Toast.fire({
				icon: "error",
				title: "Error al intentar eliminar el torneo",
				background: "#1e2836",
			});
		}
	};

	return (
		<div>
			<div className="d-flex align-items-center mb-3">
				<div>
					<h1 className="page-header mb-0">Torneos</h1>
				</div>
				<div className="ms-auto">
					<button onClick={() => openModalForCreate()} className="btn btn-outline-theme">
						<i className="fa fa-plus-circle fa-fw me-1"></i> Agregar Torneo
					</button>
					<TournamentDetailModal
						show={showModal}
						onClose={() => {
							setSelectedTournament(null)
							setShowModal(false)
						}}
						tournamentSelected={selectedTournament}
						fetchTournaments={fetchTournaments} />
				</div>
			</div>
			<Card>
				<div className="tab-content p-4">
					<div className="tab-pane fade show active" id="allTab">
						<DataTable data={tournaments}
							hiddenFields={['id']}
							columns={[
								{ key: 'nameTournament', label: 'Torneo' },
								{ key: 'startDate', label: 'Fecha de Inicio' },
								{ key: 'endDate', label: 'Fecha de Finalización' },
								{ key: 'participants', label: 'Total de Participantes' },
								{ key: 'initialized', label: 'Estado' },
							]}
							onRowClick={async (row) => await openModalForUpdate(row.id)}
							onDelete={async (row) => await onDeleteTournamente(row.id)} />
					</div>
				</div>
			</Card>
		</div>
	);
}

export default Tournaments;
